import React from 'react';

function PageTitle({ pageName = '', title, description }) {
  return (
    <div className={`page-title ${pageName}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            {title && <h2>{title}</h2>}
            {description && <p>{description}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageTitle;
